/**
 * Audit transport.
 *
 * The log is append-only and reads keyset-paginated, newest first. An event
 * publishes the changed fields on each side of the mutation — `before` and
 * `after` are the changed keys only, with anything secret-shaped already
 * refused at the source — so a reader sees what moved rather than a whole row.
 */
import type { components } from "@erp/api-client";

import { apiFetch, type Page } from "@/lib/api/http";
import { toListParams, type CursorQueryArgs, type ListFilters } from "@/features/shared/ops-api";

type Schemas = components["schemas"];

export type AuditEvent = Schemas["AuditEvent"];

export interface AuditFilters extends ListFilters {
  entity_type?: string;
  entity_id?: string;
  actor_id?: string;
  acting_branch_id?: string;
  action?: string;
  occurred_from?: string;
  occurred_to?: string;
}

/** `listAuditLog` — GET · platform.audit.read. Company-scoped: the log is not
 *  branch-scoped, because a branch cannot audit itself. */
export function listAuditLog(
  filters: AuditFilters,
  args: CursorQueryArgs = {},
): Promise<Page<AuditEvent>> {
  const { signal, ...paging } = args;
  return apiFetch<Page<AuditEvent>>("/audit-log", {
    query: { ...filters, ...toListParams(paging) },
    signal,
  });
}
